import { render } from "./ReviewsTable.vue?vue&type=template&id=4e06d8c5&scoped=true"
import script from "./ReviewsTable.vue?vue&type=script&lang=js"
export * from "./ReviewsTable.vue?vue&type=script&lang=js"

import "./ReviewsTable.vue?vue&type=style&index=0&id=4e06d8c5&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e06d8c5"]])

export default __exports__